export const DATE_FORMAT = {
  US_FORMAT: 'MM/DD/YYYY',
  EU_FORMAT: 'DD/MM/YYYY',
  ISO_FORMAT: 'YYYY-MM-DD',
  DOT_FORMAT: 'YYYY.MM.DD',
  US_LONG: 'MMMM DD, YYYY',
  EU_LONG: 'DD MMMM YYYY',
  WEEKDAY: 'ddd, MMM D, YYYY',
  //new
  ISO_DASH: 'YYYY-MM-DD',
  ISO_DOT: 'YYYY.MM.DD',
  EU_DASH: 'DD-MM-YYYY',
  EU_DOT: 'DD.MM.YYYY',
  EU_LONG: 'DD MMMM YYYY',
  DAY_MONTH: 'DD MMMM',
  WEEKDAY_LONG: 'dddd D MMMM YYYY',
  WEEKDAY_DAY_MONTH: 'dddd DD MMMM',
  DAY_NAME: 'dddd',
  SHORT_WEEKDAY_LONG: 'ddd DD MMMM YYYY',
  SHORT_WEEKDAY_DAY_MONTH: 'ddd DD MMMM',
};

export const DATE_WIDGET_TYPE = {
  TODAY: 'today',
  WEEK: 'week',
};

export const dateDefaultOptions = {
  name: 'Date Widget',
  type: DATE_WIDGET_TYPE.TODAY,
  language: 'en',
  textFont: 'Poppins',
  textSize: 12,
  weekTextSize: 12,
  format: DATE_FORMAT.DOT_FORMAT,
  fontColor: '#000000',
  backgroundColor: '#FFFFFF',
  highlightColor: '#E3003A',
  opacity: 100,
  textSeparation: 10,
  horizontalPadding: 10,
  alignment: 'center',
};

export const DATE_ALIGN_MODES = {
  LEFT: 'flex-start',
  CENTER: 'center',
  RIGHT: 'flex-end',
};

export const DATE_TEXT_ALIGN = {
  [DATE_ALIGN_MODES.LEFT]: 'left',
  [DATE_ALIGN_MODES.CENTER]: 'center',
  [DATE_ALIGN_MODES.RIGHT]: 'right',
};
